import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardRepository } from '../../../infrastructure/repositories/dashboard.repository';
import { GetDashboardWidgetDataQuery } from './get-dashboard-widget-data.query';
import { GetDashboardWidgetDataResult } from './get-dashboard-widget-data.result';

@Injectable({ providedIn: 'root' })
export class GetDashboardWidgetDataUseCase {
  private readonly _repository = inject(DashboardRepository);

  public execute(query: GetDashboardWidgetDataQuery): Observable<GetDashboardWidgetDataResult> {
    return this._repository
      .getWidgetData(query.widgetId, query.timeframe)
      .pipe(map((widgetData) => ({ widgetData })));
  }
}
